import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  Optional,
  ViewChild,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from '../../services/localStorage.service';
import { MessageService } from '../../services/message.service';
import { UtilService } from 'src/app/util/util.service';
import { ApiService } from '../../services/api.service';
import { OrderStatus } from 'src/app/order/order.enum';
import { DELETE_ICON_LARGE } from 'src/defaultImages.js';

enum Reason {
  canceledOrder = 'canceled_order',
  duplicateOrder = 'duplicate_order',
  incorrectOrderEntry = 'incorrect_order_entry',
  other = 'other',
}

@Component({
  selector: 'app-delete-created-order',
  templateUrl: './delete-created-order.component.html',
  styleUrls: ['./delete-created-order.component.css'],
})
export class DeleteCreatedOrderComponent implements OnInit {
  @ViewChild('otherInput') otherInputElement!: ElementRef<HTMLInputElement>;

  images: any = {
    DELETE_ICON_LARGE: DELETE_ICON_LARGE,
  };
  subscription = new Subscription();
  loading: boolean = false;
  translationText: any;
  orderStatusEnum = OrderStatus;
  selectedReason: string | null = null;
  otherReasonText: string = '';
  finalReason: string = '';

  reasonOptions = [
    { value: Reason.canceledOrder, reason: 'CUSTOMER_CANCELED_THE_ORDER' },
    { value: Reason.duplicateOrder, reason: 'DUPLICATE_ORDER' },
    { value: Reason.incorrectOrderEntry, reason: 'INCORRECT_ORDER_ENTRY' },
    { value: Reason.other, reason: 'OTHER_REASON' },
  ];

  constructor(
    public _dialogRef: MatDialogRef<any>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _translateService: TranslateService,
    private _localStorage: LocalStorageService,
    private _msgService: MessageService,
    private _utilService: UtilService,
    private _apiService: ApiService
  ) {}

  ngOnInit() {
    this.subscription.add(
      this._translateService.get(['DELETE_ORDER']).subscribe((translation) => {
        this.translationText = translation.DELETE_ORDER;
      })
    );
  }

  closeModal() {
    this._dialogRef.close({ status: 0, data: null, message: 'closed' });
  }

  cancelClicked() {
    this.closeModal();
  }

  deleteClicked() {
    const currOrderDetails = (this.data || {}).currOrderDetails || {};
    const payload = {
      order_no: currOrderDetails.order_no,
      order_id: currOrderDetails.order_id,
      restaurant_id: currOrderDetails.restaurant_id,
      order_status: this.orderStatusEnum.DELETE,
      timezone: this._localStorage.get('time_zone'),
      deleted_by: this._utilService.getUserName(),
      reason_text: this.finalReason,
    };
    this.loading = true;
    this._apiService.deleteAlreadyCreatedOrder(payload).subscribe(
      (res: any) => {
        this.loading = false;
        if ((res || {}).statusCode == 201) {
          this._msgService.showSuccess(
            this.translationText.ORDER_DELETED_SUCCESSFULLY
          );
        } else {
          this._msgService.handleErrors(res?.error?.message);
        }
        this.closeModal();
      },
      (error) => {
        this.loading = false;
        this._msgService.handleErrors(error?.error?.message);
        this.closeModal();
      }
    );
  }

  focusOtherInput(): void {
    if (this.selectedReason !== Reason.other) {
      this.selectedReason = Reason.other;
    }
    if (this.otherInputElement) {
      requestAnimationFrame(() => this.otherInputElement.nativeElement.focus());
    }
  }

  onReasonSelect(value: string): void {
    if (value === Reason.other) {
      this.focusOtherInput();
      this.finalReason = '';
    } else {
      const translatedReasonKey = this.reasonOptions.find(
        (option) => option?.value === value
      )?.reason;
      this.finalReason = this.translationText[translatedReasonKey];
    }
  }

  onOtherReasonChange(typedValue: string): void {
    this.finalReason = typedValue?.trim();
  }
}
